let base_url: string;

if (process.env.VUE_APP_BASE_URL) {
  base_url = process.env.VUE_APP_BASE_URL;
} else {
  base_url = "localhost";
}

export const BASE_URL = base_url;
